module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAP1BMVEUAAAAzMzMuLi4yMjIyMjIyMjIvLy8uLi4yMjIoKCgzMzMtLS0zMzMyMjIyMjIyMjIyMjIyMjIqKiowMDAzMzM7pSziAAAAFHRSTlMA/B7HwrMaIawTuRYPm+Gi8ekSJaBkrwYAAADDSURBVDjLfdRLDsMgDABR8wskLZC0vv9ZS9oFizFlE1my9BYeRXy6+ibL5+tVshyqLuXlzuFUi5w6tuLL3nmEsaNN+v3RYIo+6HiuypacTpGWurKJ5KhTpKXR38MepkgrPr/TFC3L/8Yp7gtLhCItirQo0jJFWhRhWSIsS4RlibQowrLb4B15L6MctoE7Wm2gHKsNlsM2WA47ZDm0WA4tlkNr1SotirQo0rJEWhS9dFgQq5ywIDZJsCAWyaXVv7/D1t8fo6cYz1HeoCkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-close-modal.png
// module id = aX7o
// module chunks = 1